import { render, staticRenderFns } from "./GuideDetailNavigation.vue?vue&type=template&id=207dea5f&scoped=true&"
import script from "./GuideDetailNavigation.vue?vue&type=script&lang=js&"
export * from "./GuideDetailNavigation.vue?vue&type=script&lang=js&"
import style0 from "./GuideDetailNavigation.vue?vue&type=style&index=0&id=207dea5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207dea5f",
  null
  
)

component.options.__file = "GuideDetailNavigation.vue"
export default component.exports